<template>
  <div class="relative" aria-hidden="true">
    <StaticAsset
      folder="images"
      file="character-stills_01.png"
      class="absolute top-0"
    />
  </div>
</template>
